<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4 flex-wrap">
      <v-btn-toggle v-model="activityFilter" mandatory dense class="calendar-activity-toggle mb-2 mb-sm-0">
        <v-btn small value="active">Активные</v-btn>
        <v-btn small value="inactive">Неактивные</v-btn>
        <v-btn small value="all">Все</v-btn>
      </v-btn-toggle>
      <v-btn color="#483CB9" dark small class="text-capitalize" @click="$emit('add')">
        <v-icon small left>mdi-account-plus</v-icon>
        Эксперт
      </v-btn>
    </div>

    <div v-if="!filteredExperts.length" class="text-caption grey--text text-center py-4">
      Нет экспертов, подходящих под выбранный фильтр
    </div>
    <v-row v-else>
      <v-col v-for="expert in filteredExperts" :key="expert.id" cols="12" sm="6" md="4">
        <v-sheet outlined rounded="lg" class="pa-4 expert-card">
          <div class="d-flex align-center mb-3">
            <v-avatar size="48" color="#483CB9" class="mr-3">
              <img v-if="expert.photo_url" :src="expert.photo_url" :alt="fullName(expert)">
              <span v-else class="white--text text-subtitle-2">{{ initials(fullName(expert)) }}</span>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="font-weight-bold text-body-1">{{ fullName(expert) }}</div>
              <div class="text-caption" style="color:#483CB9;">{{ expert.email }}</div>
              <v-chip v-if="!expert.is_active" x-small class="mt-1" color="#f0f0f0">Неактивен</v-chip>
            </div>
            <div class="d-flex align-center ml-2">
              <v-btn icon small class="mr-1" @click="$emit('edit', expert)">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn icon small @click="onDelete(expert.id)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </div>
          <p class="text-body-2 grey--text text--darken-2 mb-3">{{ expert.short_description }}</p>
          <div class="text-caption grey--text mb-3">Открытых интервалов: {{ availabilityCount(expert.id) }}</div>

          <div v-if="expertServices(expert.id).length" class="mb-3 d-flex flex-column align-start">
            <v-chip
              v-for="item in expertServices(expert.id)"
              :key="item.id"
              x-small
              class="mb-1"
              :color="item.is_active === false ? 'grey lighten-2' : '#ece9fb'"
            >
              {{ serviceTypeName(item.service_type) }}, {{ item.max_duration_minutes }} мин
            </v-chip>
          </div>
          <div v-else class="text-caption grey--text mb-3">Услуги не назначены</div>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ExpertsList',
  props: {
    experts: { type: Array, default: () => [] },
    availability: { type: Array, default: () => [] }, // открытые интервалы (Availability, status === 'open')
    services: { type: Array, default: () => [] },
    serviceTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      activityFilter: 'active', // active | inactive | all
    };
  },
  computed: {
    filteredExperts() {
      return this.experts.filter((expert) => {
        const isActive = expert.is_active !== false;
        if (this.activityFilter === 'active') return isActive;
        if (this.activityFilter === 'inactive') return !isActive;
        return true;
      });
    },
  },
  methods: {
    fullName(expert) {
      return `${expert.first_name || ''} ${expert.last_name || ''}`.trim();
    },
    availabilityCount(expertId) {
      return this.availability.filter((item) => item.expert === expertId).length;
    },
    expertServices(expertId) {
      return this.services.filter((item) => item.expert === expertId && item.is_active !== false);
    },
    serviceTypeName(id) {
      const serviceType = this.serviceTypes.find((item) => item.id === id);
      return serviceType ? serviceType.name : '';
    },
    initials(name) {
      return name.split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
    },
    onDelete(id) {
      // eslint-disable-next-line no-alert
      if (window.confirm('Удалить этого эксперта из календаря?')) {
        this.$emit('delete', id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.expert-card {
  height: 100%;
}

.calendar-activity-toggle .v-btn {
  text-transform: none;
}
</style>
